import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {urls} from '../../endPoint';
import {IAddress, IUser} from '../../types';
import {api} from '../../http';

interface IUserSlice {
  data: IUser;
  addresses: IAddress[];
  isLoggedIn: boolean;
  workerOffs: any
}

const initialState: IUserSlice = {
  data: {
    id: 0,
    name: '',
    lastName: '',
    nationalCode: '',
    phoneNumber: '',
    cardNumber: '',
    shebaNumber: '',
    hesabNumber: '',
    bankName: '',
    role: 'USER',
    media: { url: ''},
    profilePic: { url: ''}
  },
  workerOffs: {},
  addresses: [],
  isLoggedIn: false,
};
export const addresses = createAsyncThunk('address/fetchAddress', async () => {
  return await api(urls.address, {}, true);
});

export const userProfile = createAsyncThunk('user/fetchProfile', async () => {
  return await api(urls.getUser, {}, true);
});

export const workerOffs = createAsyncThunk('user/fetchWorkerOffs', async () => {
  return await api(urls.workerOffs, {}, true);
});

const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    SET_LOGGED_IN: (state, action: PayloadAction<boolean>) => {
      state.isLoggedIn = action.payload;
    },
    user: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addresses.fulfilled, (state, action) => {
        if (action.payload.code == 200) {
          state.addresses = action.payload.data;
        }
      })
      // .addCase(userProfile.fulfilled, (state, action) => {
      //   if (action.payload.code == 200) {
      //     state.data = action.payload.data;
      //   }
      // })
      .addCase(workerOffs.fulfilled, (state, action) => {
        if (action.payload.code == 200) {
          state.workerOffs = action.payload.data;
        }
      });
  },
});

export const {SET_LOGGED_IN, user} = userSlice.actions;

const userReducer = userSlice.reducer;
export default userReducer;
